import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";
import { usePage } from "@inertiajs/react";
import React from "react";
import { toast } from "sonner";

import useMount from "hooks/useMount";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { DefaultPageType } from "types/DefaultPageType";

const CopyLinkWrapper = ({ children }) => {
  const currentUserId = useCurrentUserId();
  const mounted = useMount();
  const { pathName } = usePage<DefaultPageType>().props;

  const copyToClipboard = e => {
    e.preventDefault();
    const referrer = currentUserId ? `?referrer_id=${currentUserId}` : "";
    const url = `https://hardcover.app${pathName}${referrer}`;
    if (Capacitor.getPlatform() === "android") {
      Clipboard.write({ string: url }).then(() => {
        toast.success(`${currentUserId ? "Referral link" : "Link"} copied!`);
      });
    } else {
      navigator.clipboard.writeText(url);
      toast.success(`${currentUserId ? "Referral link" : "Link"} copied!`);
    }
  };

  if (!mounted) {
    return null;
  }

  // Clone the child element and add the onClick event
  const childWithCopy = React.cloneElement(children, {
    onClick: copyToClipboard,
    ...children.props,
  });

  return childWithCopy;
};

export default CopyLinkWrapper;
